import { render, staticRenderFns } from "./ModalFormItem.vue?vue&type=template&id=16c0a6c2"
import script from "./ModalFormItem.vue?vue&type=script&lang=js"
export * from "./ModalFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports